/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F2_AInputs */

const en_mk_sec_pg_f2_a = /** @type {(inputs: Mk_Sec_Pg_F2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operational access is limited to the people who run the system, and only to handle incidents. We do not yet have a third-party-audited break-glass process — that is among the items on the open ledger above.`)
};

const id_mk_sec_pg_f2_a = /** @type {(inputs: Mk_Sec_Pg_F2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses operasional dibatasi pada orang yang mengelola sistem, dan hanya untuk menangani gangguan. Kami belum punya proses akses darurat yang diaudit pihak ketiga — itu termasuk yang tertulis di daftar terbuka di atas.`)
};

/**
* | output |
* | --- |
* | "Operational access is limited to the people who run the system, and only to handle incidents. We do not yet have a third-party-audited break-glass process — ..." |
*
* @param {Mk_Sec_Pg_F2_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f2_a = /** @type {((inputs?: Mk_Sec_Pg_F2_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F2_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f2_a(inputs)
	return en_mk_sec_pg_f2_a(inputs)
});